import store from '@/redux/store';
import { setFlow, updateFlow } from '@/redux/supportSlice';

const advanceFlow = (flow: string, step: string) =>
{
	const state = store.getState();
	if (!state.support.flow) return;
	if (state.support.flow.key !== flow) return;

	// Set the passed step to true
	store.dispatch(
		updateFlow({
			key: 'progress',
			value: {
				...state.support.flow.progress,
				[step]: true
			}
		})
	);
};

export default advanceFlow;
